import React, { ReactNode } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { VITE_STRIPE_PUBLISHABLE_KEY } from "../../../config";

// Initialize Stripe
const stripePromise = loadStripe(VITE_STRIPE_PUBLISHABLE_KEY);

interface StripeProviderProps {
  children: ReactNode;
  clientSecret?: string;
}

const StripeProvider: React.FC<StripeProviderProps> = ({ children }) => {
  if (!VITE_STRIPE_PUBLISHABLE_KEY) {
    console.error("Stripe publishable key not found in environment variables");
    return <>{children}</>;
  } else {
  }

  return <Elements stripe={stripePromise}>{children}</Elements>;
};

export default StripeProvider;
